import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLDivElement> {
  static values = {
    delay: Number,
    url: String
  }

  declare readonly delayValue: number
  declare readonly urlValue: string

  currentDelay = 0

  #startNewCountdown(): void {
    if (this.currentDelay !== 0) {
      clearTimeout(this.currentDelay)
    }
    this.currentDelay = window.setTimeout(() => {
      window.location.href = this.urlValue
    }, this.delayValue)
  }

  connect(): void {
    this.#startNewCountdown()

    window.addEventListener('click', () => {
      this.#startNewCountdown()
    })
    window.addEventListener('keyup', () => {
      this.#startNewCountdown()
    })
  }

  disconnect(): void {
    clearTimeout(this.currentDelay)
  }
}
